import { QueryClient } from '@tanstack/react-query';
import { getSpaPackageConfigGroupsKey } from '@common/features/spa/hooks/useGetSpaPackageConfigGroups';
import { ConfigurationGroupType } from 'shared-types/SpaPackage';

export const checkMultiGuestAvailability = (
  queryClient: QueryClient,
  propertyId: number,
  spaPackageId: number,
  date: string,
  numberOfGuests: number,
  startTime: string,
  endTime: string,
  experienceOptionId: number
): boolean | undefined => {
  if (numberOfGuests < 2) {
    return false;
  }

  const singleGuestData = queryClient.getQueryData<ConfigurationGroupType[]>(
    getSpaPackageConfigGroupsKey(propertyId, spaPackageId, date, 1, startTime, endTime)
  );

  const multiGuestData = queryClient.getQueryData<ConfigurationGroupType[]>(
    getSpaPackageConfigGroupsKey(propertyId, spaPackageId, date, numberOfGuests, startTime, endTime)
  );

  if (!singleGuestData || !multiGuestData) {
    return undefined;
  }

  const multiGuestTimeslots = multiGuestData
    .flatMap((group) => group.options || [])
    .filter((option) => option.id === experienceOptionId)
    .flatMap((option) => option.timeslots || []);

  return multiGuestTimeslots.length > 0;
};
